import { CircularProgress, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { Box } from '@/components/ui'
import type { Organization } from '@/definitions/organization'

import { OrgCard } from '../OrgCard'
import { OrgEmptyState, type OrgEmptyStateVariant } from '../OrgEmptyState'

interface OrgListProps {
  orgs: Organization[]
  isLoading: boolean
  onCreateOrg: () => void
  onResetPage: () => void
  /** Which empty state to show when the list has nothing to render. */
  emptyStateVariant: OrgEmptyStateVariant
}

export const OrgList = ({
  orgs,
  isLoading,
  onCreateOrg,
  onResetPage,
  emptyStateVariant,
}: OrgListProps) => {
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <Box variant='flex' justifyContent='center' mt={4}>
        <CircularProgress />
      </Box>
    )
  }

  if (orgs.length === 0) {
    return (
      <OrgEmptyState
        variant={emptyStateVariant}
        onCreateOrg={onCreateOrg}
        onResetPage={onResetPage}
      />
    )
  }

  return (
    <Stack spacing={1.5}>
      {orgs.map((org) => (
        <OrgCard key={org.id} org={org} onClick={() => navigate(`/orgs/${org.id}`)} />
      ))}
    </Stack>
  )
}
